export const pageRoutes = {
    LOGIN: "/login",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    DASHBOARD_ADMIN: "/admin/dashboard",
    DASHBOARD_USER: "/user/dashboard",
    DONATION_HISTORY_ADMIN: "/admin/donation-history",
    DONATION_HISTORY_USER: "/user/donation-history",
    DONORS: "/admin/donors",
    DONOR_DETAILS: "/admin/donors/{0}",
    USERS: "/admin/users",
    USER_CREATE: "/admin/users/create",
    USER_EDIT: "/admin/users/{0}/edit",
    USER_EDIT_PROFILE: "/admin/users/{0}/edit/profile",
    USER_EDIT_ACCOUNT: "/admin/users/{0}/edit/account",
    USER_DETAILS: "/admin/users/{0}",
    OFFLINE_PAYMENTS: "/admin/offline-payments",
    CAMPAIGNS: "/admin/campaign",
    REFUND_REQUEST: "/admin/refund-requests",
    CAMPAIGN_DETAILS: "/campaign/{0}",
    ADMIN_REPORTS: "/admin/reports",
    USER_REPORTS: "/user/reports",
    REPORT_CREATE: "/admin/reports/create",
    REPORT_EDIT: "/admin/reports/{0}/edit",
    PUBLIC_CAMPAIGNS: "/public-campaigns",
    CAMPAIGN_CREATE: "/admin/campaign/create",
    CAMPAIGN_EDIT: "/admin/campaign/edit/{0}",
    PATIENTS: "/admin/patients",
    PATIENTS_CREATE: "/admin/patients/create",
    PATIENTS_EDIT: "/admin/patients/edit/{0}",
    DESERVING_ITEMS: "/admin/deserving-items",
    DESERVING_ITEMS_CREATE: "/admin/deserving-items/create",
    DESERVING_ITEMS_EDIT: "/admin/deserving-items/edit/{0}",
    PROFILE: "/profile",
    PROFILE_SETTINGS: "/settings/personal",
    ACCOUNT_SETTINGS: "/settings/account",
    SUPPORT: "/support",
    CONTACT: "/contact",
    ABOUT_US: "/about-us",
    ABOUT_THALASSEMIA: "/about-thalassemia",
    TERMS_AND_CONDITIONS: "/terms-and-conditions",
    PRIVATE_POLICY: "/privacy-policy",
    EMAIL: "/email",
    PAGE_NOT_FOUND: "/error",
};
